import { mapState } from "vuex";
export default {
  computed: {
    ...mapState({
      user: "user",
    }),
  },

  methods: {
    hasPermission(permissionName) {
      if (this.user.admin.is_super) {
        return true;
      }

      return this.user.role.permissions.some(
        (permission) => permission.slug === permissionName
      );
    },
  }
}